
import React from 'react';

export const AssetValueSection: React.FC = () => {
  return (
    <section id="asset-value" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            참여 시와 불참 시의 자산가치 비교
          </h2>
          <p className="text-lg text-gray-600">
            참여는 자산가치의 상향 안정화를 기대하게 합니다
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* 참여 시 */}
          <div className="bg-green-50 border-2 border-green-200 rounded-lg p-8">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-arrow-up-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-green-700 mb-2">참여 시</h3>
              <p className="text-green-600">모아타운 사업 참여</p>
            </div>
            
            <div className="space-y-4">
              <div className="bg-white rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-2">현재 보유 대지면적</p>
                <p className="text-xl font-bold text-gray-900">60평</p>
              </div>
              
              <div className="bg-white rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-2">강남 신축 국민평형 시세</p>
                <p className="text-xl font-bold text-gray-900">25억 ~ 30억</p>
              </div>
              
              <div className="bg-white rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-2">입주권 확보</p>
                <p className="text-xl font-bold text-gray-900">2채 확보 가능</p>
              </div>
              
              <div className="bg-green-100 rounded-lg p-4 border-2 border-green-300">
                <p className="text-sm text-green-700 mb-2">총 자산가치 추정</p>
                <p className="text-2xl font-bold text-green-800">50억 ~ 60억</p>
              </div>
            </div>
          </div>
          
          {/* 불참 시 */}
          <div className="bg-gray-50 border-2 border-gray-200 rounded-lg p-8">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gray-400 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-arrow-right-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-700 mb-2">불참 시</h3>
              <p className="text-gray-600">현재 상태 유지</p>
            </div>
            
            <div className="space-y-4">
              <div className="bg-white rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-2">현재 상태</p>
                <p className="text-xl font-bold text-gray-900">노후 단독/빌라 존치</p>
              </div>
              
              <div className="bg-white rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-2">토지가격 현황</p>
                <p className="text-xl font-bold text-gray-900">정체 상태</p>
              </div>
              
              <div className="bg-gray-100 rounded-lg p-4 border-2 border-gray-300">
                <p className="text-sm text-gray-700 mb-2">실거래가</p>
                <p className="text-2xl font-bold text-gray-800">28억 7천만원</p>
                <p className="text-sm text-gray-600 mt-1">(개포로 128길, 2025년 3월 실거래가)</p>
              </div>
              
              <div className="bg-gray-100 rounded-lg p-4 border-2 border-gray-300">
                <p className="text-sm text-gray-700 mb-2">총 자산가치 추정</p>
                <p className="text-2xl font-bold text-gray-800">30억  전후</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-12 bg-yellow-50 border border-yellow-200 rounded-lg p-6 max-w-4xl mx-auto">
          <div className="flex items-start">
            <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
              <i className="ri-information-line text-yellow-600"></i>
            </div>
            <div>
              <p className="text-sm text-yellow-800 leading-relaxed">
                <strong>중요 안내:</strong> 본 수치는 설명 목적의 예시이며, 실제 결과는 사업 추진 범위와 인허가, 분양가, 시세에 따라 달라질 수 있습니다. 
                정확한 정보는 주관 기관의 공식 문서를 통해 확인하시기 바랍니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
